import request from "../libs/request";

import { BuildingId } from "../types/building";

import { ImageFileInfoEachSize } from "./talkServices";

export type ActionJson = {
  action?: string;
  actionName?: string;
  btn?: string;
  link?: string | null;
  schemeAndroid?: string;
  schemeIos?: string;
  storeAndroid?: string;
  storeIos?: string;
  target?: string;
  targetName?: string;
};

export type ServiceStatusType = "only-occupant" | "need-auth" | "setting" | "";

export type UserServiceResponse = {
  serviceId: string | null;
  serviceName: string;
  sortOrder: number;
  serviceItemType: string | null;
  serviceItemTypeName: string | null;
  serviceDetailType: string;
  target: string | null;
  needAuthorized: boolean | null;
  fileInfo: { items: ImageFileInfoEachSize[] };
  serviceTemplateId: number | null;
  serviceType?: string;

  action: string | null;
  actionJson?: ActionJson[];
  actionInfoFileInfo?: { items: ImageFileInfoEachSize[] } | null;
  iconUrl: string | null;
  serviceStatus: "only-occupant" | "need-auth" | "setting" | "" | null;
  serviceStatusParams: string;
};

export type GetTotalServiceRequest = {
  isManager?: boolean;
  buildingId?: string;
};

export const getTotalService = (params: GetTotalServiceRequest) =>
  request.get<UserServiceResponse[]>("group/service/list", { params });

export type SearchServiceRequest = {
  searchWord?: string;
  buildingId?: string;
  page?: number;
  pageSize?: number;
  serviceType?: string;
};

export const searchService = (params: SearchServiceRequest) =>
  request.get("group/service/list/search", { params });

export type ServiceGroupCategoryType =
  | "RENTAL"
  | "SPACE"
  | "BUILDING_BBS"
  | "CAFETERIA"
  | "VOC"
  | "MONITORING";

export type GetBuildingListRequest = BuildingId & {
  categoryCode: ServiceGroupCategoryType;
};

export type ServiceGroupItem = BuildingId & {
  groupId: string;
  buildingName: string;
};

export const getBuildingList = (params: GetBuildingListRequest) =>
  request.get<ServiceGroupItem[]>("group/service/group/building-list", {
    params,
  });
